// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Addon } from './addon';
import { JoDetail } from './jo-detail';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class JoDetailAddon extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** String(255) */
  additionalInfo?: string;
  /** Int32 FK addon */
  addonId?: number;
  /** Int32 */
  cDM_KEY?: number;
  /** String(512) */
  cDM_NOTE?: string;
  /** Int32 FK joDetail */
  joDetailId!: number;
  /** String(60) */
  mOD_DESCRIPTION?: string;
  /** Decimal */
  unitPriceAmt?: number;
  /** FK addonId */
  addon!: Addon;
  /** FK joDetailId */
  joDetail!: JoDetail;
}

